import styled from '@emotion/styled';
import { rem } from '@utils';

const Header = styled.header<{ isPanelView?: boolean }>(
  ({ isPanelView, theme }) => `
  align-items: center;
  background: ${theme.palette.common.white};
  border-bottom: 1px solid ${theme.palette.grey[200]};
  color: inherit;
  display: flex;
  gap: ${rem(8)};
  height: var(--action-panel-height);
  justify-content: space-between;
  padding: ${rem(16)} ${rem(24)};
  position: sticky;
  top: 0;
  z-index: 2;

  @media (max-width: 768px) {
    padding: ${rem(8)} ${rem(24)};
  }

  ${
    isPanelView
      ? `
  @media (max-width: 1024px) {
    border-bottom: none;
    height: auto;
    justify-content: center;
    padding: ${rem(16)};
    transition: box-shadow 100ms ease;

    &.shadow {
      box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.08);
    }
  }
`
      : ''
  }
`
);

const HeaderLeading = styled.div<{ isPanelView?: boolean }>(
  ({ isPanelView }) => `
  align-items: center;
  display: flex;
  gap: ${rem(8)};

  ${
    isPanelView
      ? `
  @media (max-width: 1024px) {
    flex-grow: 1;
    justify-content: center;
    margin-left: -${rem(40)};
    order: 2;
  }
`
      : ''
  }
`
);

const Title = styled.h3<{ isPanelView?: boolean }>(
  ({ isPanelView }) => `
  color: inherit;
  font-size: ${rem(20)};
  font-weight: 600;
  line-height: ${rem(32)};
  margin-bottom: 0;

  @media (max-width: 636px) {
    font-size: ${rem(16)};
    line-height: ${rem(24)};
  }

  ${
    isPanelView
      ? `
  @media (max-width: 1024px) {
    font-size: ${rem(16)};
    line-height: ${rem(24)};
    text-align: center;
  }
`
      : ''
  }
`
);

const CloseButton = styled.button(
  ({ theme }) => `
  align-items: center;
  background: none;
  border: none;
  border-radius: 4px;
  box-sizing: content-box;
  color: inherit;
  cursor: pointer;
  display: flex;
  height: ${rem(24)};
  justify-content: center;
  transition: 100ms ease;
  width: ${rem(24)};

  .close {
    height: ${rem(14)};
    width: ${rem(14)};
  }

  .back {
    display: none;
    height: ${rem(16)};
    width: ${rem(16)};
  }

  &:hover {
    color: ${theme.palette.primary.main};
  }

  &:active {
    background: ${theme.palette.primary.dark};
    color: ${theme.palette.common.white};
  }

  @media (max-width: 1024px) {
    order: 1;
    z-index: 1;

    .back {
      display: block;
    }

    .close {
      display: none;
    }
  }
`
);

const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  margin-inline: auto;
  max-width: ${rem(1200)};
  min-height: 0;
  overflow: hidden auto;
  overscroll-behavior: none;
  padding: ${rem(24)} ${rem(24)} ${rem(64)} ${rem(24)};
  width: 100%;

  && {
    scrollbar-gutter: initial;
  }

  @media (max-width: 430px) {
    padding: ${rem(16)};
  }
`;

const ArtifactCapture = styled.div`
  background: var(--right-panel-background-color);
  display: block;
  width: 100%;
`;

const ArtifactToolbar = styled.div`
  align-items: center;
  display: flex;
  gap: ${rem(16)};
  justify-content: space-between;
  margin-bottom: ${rem(24)};

  @media (max-width: 640px) {
    align-items: flex-start;
    flex-direction: column;
  }
`;

const ArtifactTitle = styled.h2(
  ({ theme }) => `
  color: ${theme.palette.common.black};
  font-size: ${rem(20)};
  font-weight: 600;
  line-height: ${rem(32)};
  margin: 0;
`
);

const Description = styled.p(
  ({ theme }) => `
  color: ${theme.palette.grey['600']};
  font-size: ${rem(14)};
  line-height: ${rem(20)};
  margin: 0 0 ${rem(24)};
`
);

export default {
  ArtifactCapture,
  ArtifactToolbar,
  ArtifactTitle,
  CloseButton,
  Content,
  Description,
  Header,
  HeaderLeading,
  Title
};
